import { useRouter } from "next/router";

const SpecificationsTab = ({ data }) => {
  const { locale } = useRouter();
  function unescapeHtml(escapedHtml) {
    const htmlEntities = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'",
    };

    return escapedHtml?.replace(
      /&amp;|&lt;|&gt;|&quot;|&#39;/g,
      (match) => htmlEntities[match]
    );
  }

  console.log(Object.values(data?.at(0)["1"]).at)
  return data?.length ? (
    <div className="bg-[#f6f2f2]">
      {data?.map((item) => (
        <>
          <div
            dangerouslySetInnerHTML={{
              __html: locale === "ar" ? unescapeHtml(Object.values(item["1"])?.at(0)?.value) : unescapeHtml(Object.values(item["2"])?.at(0)?.value),
            }}
            className=" product__dynamic-table max-sm:text-xs"
          />
        </>
      ))}
    </div>
  ) : null;
};

export default SpecificationsTab;
